<script lang="ts">
  import type { Snippet } from "svelte";
  import { popoverShiftPx } from "./popoverClamp.ts";

  interface Props {
    id: string;
    label: string;
    open: boolean;
    ontoggle: () => void;
    children?: Snippet;
  }

  let { id, label, open, ontoggle, children }: Props = $props();

  // HUD-POPOVER-CLIP-390-1: measured once per open, before any shift is applied (the popover mounts at 0).
  let popover = $state<HTMLDivElement | null>(null);
  let shift = $state(0);
  $effect(() => {
    if (!open || !popover) { shift = 0; return; }
    const rect = popover.getBoundingClientRect();
    shift = popoverShiftPx(rect.left, rect.right, window.innerWidth);
  });
</script>

<div class="panel-info">
  <button
    type="button"
    class="info-button"
    aria-expanded={open}
    aria-controls={id}
    aria-label={label}
    onclick={ontoggle}>ⓘ</button>
  {#if open}
    <div id={id} class="range-info-popover" role="dialog" aria-label={label} bind:this={popover}
      style:translate={shift === 0 ? null : `${shift}px 0`} data-popover-shift={shift}>
      {@render children?.()}
    </div>
  {/if}
</div>

<style>
  .panel-info { position: relative; display: inline-flex; }
  .info-button {
    margin-left: 0;
    padding: 2px 6px;
    border: 1px solid var(--line);
    border-radius: var(--radius-pill);
    background: var(--chip);
    color: var(--faint);
    font: inherit;
    cursor: pointer;
  }
  .info-button:focus-visible { outline: 2px solid var(--accent); outline-offset: 2px; }
  .range-info-popover {
    position: absolute;
    z-index: 20;
    top: calc(100% + 8px);
    right: 0;
    width: min(520px, calc(100vw - 32px));
    box-sizing: border-box;
    border: 1px solid var(--line);
    border-radius: 5px;
    background: var(--surface-2);
    color: var(--muted);
    padding: 8px 10px;
    font-size: 10px;
    line-height: 1.45;
    box-shadow: var(--shadow);
  }
  .range-info-popover p { margin: 2px 0; }
  .range-info-popover dl { margin: 2px 0; }
  .range-info-popover dt { color: var(--ink); font-weight: 700; }
  .range-info-popover dd { margin: 0 0 3px; }
</style>
